export default function SparkleIcon({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g className='sparkle-large'>
        <path d='M7.5 2L9 6.5L13.5 8L9 9.5L7.5 14L6 9.5L1.5 8L6 6.5L7.5 2Z' fill='white' />
      </g>
      <g className='sparkle-small'>
        <path d='M13.5 1L14 2.5L15.5 3L14 3.5L13.5 5L13 3.5L11.5 3L13 2.5L13.5 1Z' fill='white' />
      </g>
    </svg>
  );
}
